/**
 * Hook to access socket context
 */
import { SocketContext } from '@/contexts/socket.context'
import * as React from 'react'

export const useSocket = () => {
  const context = React.useContext(SocketContext)
  if (context === undefined) throw new Error('useSocket must be used within a SocketProvider')
  return context
}
